<app-images-form
    [edit]="false"
    [create]="false"
    [delete]="false"
    [details]="true"
    [access]="access()"
    [value]="value()"
  ></app-images-form>
